import { use } from 'react';
import { AuthContext } from './AuthContext';

/**
 * Hook for accessing authentication state and actions.
 *
 * Must be used inside an <AuthProvider>. Exposes:
 *   - isAuthenticated: whether the user has a valid session
 *   - isLoading: true while MSAL is processing a redirect or in progress
 *   - user: display name, email, and account ID (null when not authenticated)
 *   - signIn(): triggers a Microsoft Entra ID login redirect
 *   - signOut(): triggers a Microsoft Entra ID logout redirect
 *   - getAccessToken(): acquires an access token for the configured API scopes;
 *     uses silent acquisition where possible, redirects for re-auth if needed
 */
export function useAuth() {
    const ctx = use(AuthContext);

    if (!ctx) {
        throw new Error('useAuth must be used within an <AuthProvider>');
    }

    return ctx;
}
